import { datadogLogs } from '@datadog/browser-logs';
import { sharedInitOptions } from '../datadog/datadog-config';

export const { logger } = datadogLogs;

export function initLogger() {
  datadogLogs.init({
    ...sharedInitOptions,
    forwardErrorsToLogs: true,
    beforeSend: (event) => {
      // Don't log aborted requests - this can happen intentionally such as when
      // a user navigates between pages
      if (
        event.error &&
        event.http?.status_code === 0 &&
        event.error.kind === 'AbortError'
      ) {
        return false;
      }
      // Always send event - return false to skip sending
      return true;
    },
  });

  if (process.env.NODE_ENV === 'production') {
    // Send logs to Datadog when in production
    logger.setHandler('http');
    logger.setLevel('info');
  } else {
    // Otherwise, do not send logs to Datadog and instead
    // send them to the console
    logger.setHandler('console');
  }
}
